import React from "react";
import { Cell, Column, SelectionModes, Table } from "@blueprintjs/table";
import SortableColumnHeaderCell from "components/blueprinttable/SortableColumnHeaderCell";
import useSortableData from "hooks/useSortableData";
import { momentOrNull } from "common/util";

const CovidDetail = (props) => {
  console.log(props.data);
  const initialData = props.data.map((row) => {
    const getVal = (obj, field) => obj && obj[field];
    return {
      ...row,
      currentCarrierName: getVal(row.currentCarrier, "desig"),
      departureName: getVal(row.departure, "name"),
      destinationName: getVal(row.destination, "name"),
      customerName: getVal(row.customer, "name"),
      transporterName: getVal(row.transporter, "name"),
      employerName: getVal(row.employer, "name"),
      finalizationReasonType: row.finalizationReasonType,
    };
  });

  const [data, { setSortKey, currentSortKey, currentSortDir }] =
    useSortableData(initialData);

  const columns = [
    {
      name: "Check-In-Time",
      key: "checkedInTime",
      formatter: (value) => momentOrNull(value)?.format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      name: "Last Name",
      key: "lastName",
    },
    {
      name: "First Name",
      key: "firstName",
    },
    {
      name: "Customer",
      key: "customerName",
    },
    {
      name: "Employer",
      key: "employerName",
    },
    {
      name: "Departure",
      key: "departureName",
    },
    {
      name: "Destination",
      key: "destinationName",
    },
    {
      name: "Symptoms",
      key: "covid_hasFluSymptoms",
      formatter: (value) => (value ? "Yes" : "No"),
    },
    {
      name: "Has High Temp",
      key: "covid_selfReportedHighBodyTemperature",
      formatter: (value) => (value ? "Yes" : "No"),
    },
    {
      name: "Exposed to Covid",
      key: "covid_ExposedToVirus",
      formatter: (value) => (value ? "Yes" : "No"),
    },
    {
      name: "Vaccinated",
      key: "covid_hasBeenVaccinated",
      formatter: (value) => (value ? "Yes" : "No"),
    },
  ].map((col) => {
    const cellRenderer = (i) => {
      const value = col.formatter
        ? col.formatter(data[i]?.[col.key])
        : data[i]?.[col.key];
      return (
        <Cell tooltip={value} style={{ display: "flex", alignItems: "center" }}>
          {value}
        </Cell>
      );
    };
    return (
      <Column
        key={col.key}
        name={col.name}
        cellRenderer={cellRenderer}
        columnHeaderCellRenderer={() => (
          <SortableColumnHeaderCell
            name={col.name}
            sortKey={col.key}
            onSort={setSortKey}
            currentSortedKey={currentSortKey}
            currentSortDir={currentSortDir}
          />
        )}
      />
    );
  });

  return (
    <Table
      selectionModes={SelectionModes.NONE}
      className="mc-table"
      numRows={data?.length}
    >
      {columns}
    </Table>
  );
};

export default CovidDetail